// @core/api/endpoints/notifications/validate_contact_value.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ValidateContactValueRequest,
  ValidateContactValueResponse,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Validate contact value format
 * Validates the format of a contact value such as email or phone number. Returns validation results and suggestions for corrections if needed.
 * @public This endpoint does not require authentication
 */
export async function ValidateContactValue(
  data: ValidateContactValueRequest,
  options?: RequestOptions
): Promise<ValidateContactValueResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/contacts/validate`;
  const requestOptions = { ...options, skipAuth: true };
  return client.post<ValidateContactValueResponse>(requestPath, data, requestOptions);
}
